import BaseComponent from '../../../../../common/js/BaseComponent';
import Helper from '../../../../../common/utils/helper';

export default class ProductSearch extends BaseComponent {
    private urlSearch: string;

    private urlSearchSuggestions: string;

    private form: HTMLElement;

    // eslint-disable-next-line no-undef
    private submitSearchButtons: NodeListOf<HTMLElement>;

    // eslint-disable-next-line no-undef
    private inputSearchFields: NodeListOf<HTMLInputElement>;

    protected init(): void {
        // Initialisation des données de base
        // URL de la page de recherche
        this.form = this.view;

        this.initComponents();

        // Détection si on est déjà sur la page de recherche ou pas
        // Si oui, on relance juste une recherche AJAX Sinon on redirige vers la page de recherche avec le term
        this.initEvents();
    }

    protected initAdditionalVar(): void {
        this.urlSearch = this.view.dataset.urlSearch ?? '';
        this.urlSearchSuggestions = this.view.dataset.urlSearchSuggestions ?? '';
    }

    protected initComponents(): void {
        this.submitSearchButtons = this.form.querySelectorAll('.submit-search-button');
        this.inputSearchFields = this.form.querySelectorAll('.input-search-field');
    }

    protected initEvents() {
        this.initSearchAutocomplete();
        this.initSearchExecution();
    }

    /**
     * Chargement de l'autocomplete pendant la saisie de texte dans le champ de recherche
     */
    protected initSearchAutocomplete() {
        // TODO implémenter la recherche par suggestion de mots clef à l'autocompletion du champs input.
        this.inputSearchFields.forEach((item) => {
            item.addEventListener('input', (e) => {
                e.preventDefault();
                // Comme il peut y avoir plusieurs formulaires de recherche sur une page (mobile et desktop), il faut
                // récupérer l'input qui est rattaché au submit qui a été cliqué
                const form = item.closest('.search-form');
                if (form !== null) {
                    this.executeSearchSuggestions(item); // Envoyer le champ input search
                }
            });
        });
    }

    /**
     * Chargement des évènements clic sur la loupe et appui sur la touche Enter pour lancer la recherche à partir
     * de la chaine de caractère saisie
     */
    protected initSearchExecution() {
        // Détection de clic sur le bouton submit de recherche
        this.submitSearchButtons.forEach((item) => {
            item.addEventListener('click', (e) => {
                e.preventDefault();
                // Comme il peut y avoir plusieurs formulaires de recherche sur une page (mobile et desktop), il faut
                // récupérer l'input qui est rattaché au submit qui a été cliqué
                const form = item.closest('.search-form');
                if (form !== null) {
                    const inputField : HTMLInputElement | null = form.querySelector('.input-search-field');
                    if (inputField !== null) {
                        this.executeSearch(inputField); // Envoyer le champ input search
                    }
                }
            });
        });

        // Détection d'appui sur la touche entrer depuis un champ de recherche
        this.inputSearchFields.forEach((item) => {
            item.addEventListener('keypress', (e) => {
                // On utilise key car keyCode et charCode sont deprecated.
                if (e.key === 'Enter') {
                    this.executeSearch(item);
                }
            });
        });
    }

    /**
     * Exécution de la recherche
     *
     * @param inputSearchField
     * @private
     */
    private executeSearch(inputSearchField: HTMLInputElement):void {
        // Récupération de l'input attaché au bouton cliqué pour en récupérer le contenu texte à utiliser comme term
        const term = inputSearchField.value;
        // @ts-ignore
        window.location = `${this.urlSearch}?term=${term}`;
    }

    /**
     * À partir de 3 caractères saisis on lance une recherche pour afficher des suggestions au client.
     *
     * @param inputSearchField
     * @private
     */
    private executeSearchSuggestions(inputSearchField: HTMLInputElement):void {
        const form = inputSearchField.closest('.search-form');

        if (form !== null) {
            const suggestedProductsContainer = form.querySelector('.suggested-products-container');

            if (inputSearchField.value !== null && inputSearchField.value.length >= 3) {
                fetch(this.urlSearchSuggestions, {
                    method: 'POST',
                    headers: Helper.createFetchHeader(),
                    body: JSON.stringify({
                        term: inputSearchField.value,
                    }),
                })
                    .then((response) => Promise.all([response, response.json()]))
                    .then(([response, data]) => {
                        suggestedProductsContainer!.innerHTML = data.products;
                        if (!response.ok) {
                            throw new Error(data.message);
                        }
                    });
            } else {
                this.clearSuggestedProductsContainer(suggestedProductsContainer!);
            }
        }
    }

    /**
     * Nettoyage du contenu des suggestions de produits si la saisie est inférieure au minimum de caractères
     * requis pour afficher les suggestions.
     *
     * @private
     */
    private clearSuggestedProductsContainer(container: Element):void {
        // Si le conteneur n'est pas transmis en paramètre, alors on cherche à récupérer tous les conteneurs.
        // C'est-à-dire le conteneur desktop et le conteneur mobile chacun dans une modale différente.
        if (container === null) {
            const containers = this.form.querySelectorAll('.suggested-products-container');
            containers.forEach((item) => {
                item.innerHTML = '';
            });
        } else {
            container.innerHTML = '';
        }
    }
}
